import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function BonusWatcherLogo({ sx = {}, ...props }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ...sx
      }}
      {...props}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="16"
          cy="16"
          r="14"
          stroke={theme.palette.primary.main}
          strokeWidth="2.5"
          strokeDasharray="4 4"
        />
        <circle
          cx="16"
          cy="16"
          r="10"
          fill={theme.palette.primary.main}
          fillOpacity="0.2"
        />
        <path
          d="M16 8V16L20 20"
          stroke={theme.palette.primary.main}
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12L14 14M18 12L16 14"
          stroke={theme.palette.primary.main}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <Typography
        variant="h6"
        component="span"
        sx={{
          fontWeight: 700,
          background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: '0.5px'
        }}
      >
        Bonus Watcher
      </Typography>
    </Box>
  );
} 